var map = {
	"./icon-american-express.svg": 51451,
	"./icon-amex.svg": 41527,
	"./icon-app-store.svg": 99019,
	"./icon-apple.svg": 69518,
	"./icon-argentina-area.svg": 77421,
	"./icon-arrow-back.svg": 33787,
	"./icon-arrow-bread.svg": 32916,
	"./icon-arrow-details.svg": 93920,
	"./icon-arrow-double.svg": 88573,
	"./icon-arrow-down-orange.svg": 9241,
	"./icon-arrow-down-top.svg": 93804,
	"./icon-arrow-down.svg": 97078,
	"./icon-arrow-left-button.svg": 47490,
	"./icon-arrow-left.svg": 36989,
	"./icon-arrow-next.svg": 28141,
	"./icon-arrow-notification.svg": 26011,
	"./icon-arrow-right-button.svg": 92309,
	"./icon-arrow-right-gray.svg": 81716,
	"./icon-arrow-right-orange.svg": 29559,
	"./icon-arrow-right.svg": 82496,
	"./icon-arrow-slide-white.svg": 9209,
	"./icon-arrow-slide.svg": 19173,
	"./icon-assinatura-perfil copy.svg": 34549,
	"./icon-assinatura-perfil.svg": 86298,
	"./icon-assinatura.svg": 78527,
	"./icon-aura.svg": 25839,
	"./icon-back.svg": 10463,
	"./icon-backstaage.svg": 43944,
	"./icon-ballon-password.svg": 54048,
	"./icon-banescard.svg": 37191,
	"./icon-bell.svg": 67257,
	"./icon-block.svg": 74769,
	"./icon-brand-logo.svg": 2799,
	"./icon-branding-comunidade.svg": 82807,
	"./icon-bullet-staagejobs.svg": 13688,
	"./icon-bullet.svg": 22038,
	"./icon-button-google-play.svg": 39097,
	"./icon-cabal.svg": 93999,
	"./icon-camera.svg": 69743,
	"./icon-cancel-credit.svg": 40822,
	"./icon-cancel-renew.svg": 71820,
	"./icon-cancel-sign.svg": 62874,
	"./icon-cancel.svg": 73612,
	"./icon-card-tooltip.svg": 9926,
	"./icon-caret-blue.svg": 14800,
	"./icon-caret-select.svg": 69508,
	"./icon-caret.svg": 1107,
	"./icon-cellphone.svg": 46714,
	"./icon-certificate-gray.svg": 60777,
	"./icon-certificate-orange.svg": 27642,
	"./icon-certificate-outline.svg": 15694,
	"./icon-certificate.svg": 63259,
	"./icon-check-black.svg": 15488,
	"./icon-check-circle.svg": 89087,
	"./icon-check-country.svg": 53567,
	"./icon-check-orange.svg": 4325,
	"./icon-check-radio-orange.svg": 92335,
	"./icon-check-white.svg": 44734,
	"./icon-checkbox.svg": 89313,
	"./icon-checked-circle-white.svg": 97662,
	"./icon-checked-green.svg": 61363,
	"./icon-checked.svg": 86949,
	"./icon-chile-area.svg": 23641,
	"./icon-cientista-do-marketing.svg": 11249,
	"./icon-circle-lines.svg": 84608,
	"./icon-clock-gray.svg": 30892,
	"./icon-clock-time.svg": 69674,
	"./icon-clock.svg": 92552,
	"./icon-close-black-circle-white.svg": 65165,
	"./icon-close-black.svg": 46492,
	"./icon-close-circle-white.svg": 54747,
	"./icon-close-circle.svg": 30187,
	"./icon-close-gray.svg": 2382,
	"./icon-close-white.svg": 25370,
	"./icon-close.svg": 78126,
	"./icon-concluidos.svg": 8573,
	"./icon-config.svg": 73200,
	"./icon-conquista.svg": 94865,
	"./icon-conquistas.svg": 18912,
	"./icon-contato.svg": 22976,
	"./icon-copywriting.svg": 92163,
	"./icon-coroa.svg": 59850,
	"./icon-credit-card-orange.svg": 35295,
	"./icon-credit-card.svg": 38696,
	"./icon-credit-error.svg": 48244,
	"./icon-dados-pessoais.svg": 26895,
	"./icon-dados.svg": 15247,
	"./icon-decorative-money.svg": 46107,
	"./icon-description.svg": 328,
	"./icon-details.svg": 42476,
	"./icon-detalhes.svg": 18922,
	"./icon-diners.svg": 29617,
	"./icon-dinners-club.svg": 20510,
	"./icon-discorver-themes.svg": 66728,
	"./icon-discover.svg": 71363,
	"./icon-document-checked-white.svg": 82645,
	"./icon-download.svg": 33178,
	"./icon-ecommerce.svg": 72954,
	"./icon-elo.svg": 93328,
	"./icon-empty-avisos.svg": 83053,
	"./icon-empty.svg": 65497,
	"./icon-endereco.svg": 10283,
	"./icon-episode.svg": 49113,
	"./icon-episodes.svg": 32024,
	"./icon-error.svg": 18400,
	"./icon-eye.svg": 18109,
	"./icon-facebook-fill.svg": 25272,
	"./icon-favorite-in.svg": 45034,
	"./icon-favorite-out.svg": 46813,
	"./icon-favorited-empty.svg": 6202,
	"./icon-favorited-full.svg": 62668,
	"./icon-file-orange.svg": 94119,
	"./icon-file.svg": 73872,
	"./icon-fire-filled.svg": 25571,
	"./icon-fire.svg": 32646,
	"./icon-form.svg": 75360,
	"./icon-forward.svg": 3193,
	"./icon-fullscreen.svg": 63633,
	"./icon-fundador.svg": 72511,
	"./icon-geral.svg": 32455,
	"./icon-google-play.svg": 462,
	"./icon-google.svg": 18487,
	"./icon-grid.svg": 58282,
	"./icon-hashtag.svg": 64510,
	"./icon-help.svg": 29171,
	"./icon-helpcenter.svg": 25912,
	"./icon-hipercard.svg": 22258,
	"./icon-historia-gray.svg": 89021,
	"./icon-historia.svg": 50743,
	"./icon-info-active.svg": 33985,
	"./icon-info-inactive.svg": 41076,
	"./icon-info-xs.svg": 87496,
	"./icon-info.svg": 81762,
	"./icon-jcb.svg": 49167,
	"./icon-keep-details.svg": 87344,
	"./icon-keep-play.svg": 38012,
	"./icon-lancamentos.svg": 14037,
	"./icon-last.svg": 72118,
	"./icon-level.svg": 98532,
	"./icon-link-outline.svg": 78515,
	"./icon-link.svg": 72330,
	"./icon-linkedin-fill.svg": 35830,
	"./icon-list.svg": 61182,
	"./icon-location.svg": 4951,
	"./icon-lupa-white.svg": 6350,
	"./icon-lupa.svg": 31298,
	"./icon-maestro.svg": 45961,
	"./icon-mail.svg": 96031,
	"./icon-maisassistidos.svg": 4124,
	"./icon-map-pin.svg": 65034,
	"./icon-mastercard.svg": 90958,
	"./icon-materiais-gray.svg": 35781,
	"./icon-materiais.svg": 44655,
	"./icon-mentorship.svg": 78939,
	"./icon-my-progess-colored.svg": 58421,
	"./icon-my-progress.svg": 2560,
	"./icon-napratica.svg": 7733,
	"./icon-negocios-vendas.svg": 46667,
	"./icon-new-play.svg": 99583,
	"./icon-new.svg": 23200,
	"./icon-next-episode.svg": 41357,
	"./icon-ngm.svg": 75280,
	"./icon-no-content.svg": 31415,
	"./icon-not-found.svg": 12642,
	"./icon-notifications.svg": 96710,
	"./icon-out-fullscreen.svg": 76840,
	"./icon-padlock-red.svg": 67802,
	"./icon-paypal.svg": 44231,
	"./icon-perfil-complete.svg": 58792,
	"./icon-picture-in-picture.svg": 70445,
	"./icon-plano.svg": 4338,
	"./icon-platform.svg": 69135,
	"./icon-play-black.svg": 65602,
	"./icon-play-learning.svg": 92439,
	"./icon-play.svg": 94664,
	"./icon-player.svg": 6925,
	"./icon-playlist.svg": 43696,
	"./icon-plus-square.svg": 59650,
	"./icon-plus.svg": 54086,
	"./icon-portfolio.svg": 95426,
	"./icon-premium-star.svg": 94242,
	"./icon-premium.svg": 37069,
	"./icon-privacy.svg": 24170,
	"./icon-professionals.svg": 84122,
	"./icon-profile-square.svg": 84427,
	"./icon-profile.svg": 9913,
	"./icon-qtd.svg": 22591,
	"./icon-question-square-outline.svg": 92607,
	"./icon-question.svg": 97250,
	"./icon-questions-market.svg": 64418,
	"./icon-quiz-circle-orange.svg": 17617,
	"./icon-quiz.svg": 25361,
	"./icon-radio-check-orange.svg": 25791,
	"./icon-recommended.svg": 50199,
	"./icon-record.svg": 59025,
	"./icon-redes-sociais.svg": 66571,
	"./icon-remove-playlist.svg": 68689,
	"./icon-repeat-green.svg": 57717,
	"./icon-repeat.svg": 18835,
	"./icon-restart.svg": 99107,
	"./icon-rewards.svg": 35802,
	"./icon-rewind.svg": 82167,
	"./icon-search-orange.svg": 40869,
	"./icon-search.svg": 77490,
	"./icon-send.svg": 6924,
	"./icon-senha-acesso.svg": 61600,
	"./icon-senha.svg": 79545,
	"./icon-settings.svg": 21697,
	"./icon-share-fill.svg": 36619,
	"./icon-share-link-fill.svg": 77898,
	"./icon-share-link.svg": 12960,
	"./icon-share.svg": 57623,
	"./icon-show-episodes-active.svg": 53935,
	"./icon-show-episodes.svg": 18772,
	"./icon-signature-active.svg": 39335,
	"./icon-signature-check.svg": 74399,
	"./icon-signature.svg": 12892,
	"./icon-skill.svg": 97661,
	"./icon-sleep.svg": 92435,
	"./icon-smile copy.svg": 857,
	"./icon-smile.svg": 23070,
	"./icon-smileys.svg": 84946,
	"./icon-snippet-red.svg": 90903,
	"./icon-sorocred.svg": 301,
	"./icon-sound-disable.svg": 82020,
	"./icon-sound-max.svg": 18706,
	"./icon-sound-medium.svg": 90517,
	"./icon-sound-min.svg": 67668,
	"./icon-square.svg": 40191,
	"./icon-staage-white.svg": 57069,
	"./icon-staage.svg": 53673,
	"./icon-staageclass-orange.svg": 54070,
	"./icon-staageclass.svg": 41879,
	"./icon-staagedocs.svg": 68308,
	"./icon-staagejobs.svg": 33953,
	"./icon-staager.svg": 8153,
	"./icon-stagedocs.svg": 66277,
	"./icon-star-1.svg": 84896,
	"./icon-star-circle-orange.svg": 48846,
	"./icon-star-fill.svg": 53612,
	"./icon-star-o.svg": 41686,
	"./icon-star-orange-outline.svg": 45936,
	"./icon-star-orange.svg": 26709,
	"./icon-star-outline.svg": 2651,
	"./icon-star.svg": 78530,
	"./icon-stop.svg": 26394,
	"./icon-success.svg": 219,
	"./icon-time.svg": 20349,
	"./icon-timer.svg": 85173,
	"./icon-trafego-pago.svg": 52006,
	"./icon-trail-orange.svg": 82897,
	"./icon-trail.svg": 92558,
	"./icon-trash-red.svg": 94238,
	"./icon-trash-white.svg": 972,
	"./icon-trash.svg": 46076,
	"./icon-trending.svg": 11837,
	"./icon-union-professionalModal.svg": 8616,
	"./icon-unsubscribe-portugal.svg": 62048,
	"./icon-v4.svg": 91804,
	"./icon-v4academy.svg": 54802,
	"./icon-visa.svg": 99465,
	"./icon-warning.svg": 79142,
	"./icon-watching.svg": 99209,
	"./icon-whatsapp-white.svg": 36308,
	"./icon-whatsapp.svg": 13556
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84886;